import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// @ts-expect-error pure js
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
// @ts-expect-error pure js
import Spinner from "../../components/UI/Spinner";
import Callout from "../../components/UI/Callout";
import Button from "../../components/UI/Button";
import Title from "../../components/UI/Title";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import styles from "./PennylaneCallbackPage.module.css";

type Status = "loading" | "success" | "error";

export default function PennylaneCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const axios = useAuthenticatedAxios();

  const code = searchParams.get("code");
  const state = searchParams.get("state");

  const hasParams = Boolean(code && state);
  const [status, setStatus] = useState<Status>(hasParams ? "loading" : "error");
  const [companyName, setCompanyName] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(
    hasParams ? null : "Paramètres manquants dans l'URL de callback",
  );
  const exchangeStartedRef = useRef(false);

  useEffect(() => {
    if (!hasParams || exchangeStartedRef.current) {
      return;
    }
    exchangeStartedRef.current = true;

    async function exchangeCode() {
      try {
        const response = await axios.post(
          `/profiles/pennylane/oauth/callback`,
          { code, state },
        );
        setStatus("success");
        setCompanyName(response.data.company_name ?? null);
        const idProfile = response.data.id_profile;
        setTimeout(() => {
          navigate(`/bailleur/profiles/${idProfile}`, { replace: true });
        }, 2000);
      } catch (err) {
        setStatus("error");
        setError(handleAPIError(err));
      }
    }

    exchangeCode();
  }, [code, state, navigate, axios, hasParams]);

  if (status === "loading") {
    return (
      <div className={styles.container}>
        <Title variant="mega">Connexion à Pennylane en cours...</Title>
        <Spinner width="5em" />
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className={styles.container}>
        <Title variant="mega">Connexion réussie</Title>
        <Callout variant="success">
          {companyName
            ? `Qalimo est autorisé à transmettre vos factures à la société « ${companyName} » sur Pennylane.`
            : "Votre compte Pennylane a été connecté avec succès."}{" "}
          Redirection en cours...
        </Callout>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Title variant="mega">Erreur de connexion</Title>
      <Callout variant="danger">{error}</Callout>
      <Button onClick={() => navigate("/bailleur/profiles")}>
        Retour aux profils
      </Button>
    </div>
  );
}
